import React, { Component } from "react";
import { connect } from "react-redux";
import { DetailsComponent } from "./DetailsComponent";
import {
  setCurrentCreative,
  approveMaterial,
  setModalVisible,
  annotationSave
} from "./../../../redux/actions/index";
import { Row, Col, Modal, Input, Button } from "antd";
import { imageUrlPath } from "../../../components/Settings";
import placeholder from "../../../media/placeholder.png";
import { setTableFieldPairs } from "../../../components/Helpers";
const { TextArea } = Input;
const mapDispatchToProps = dispatch => {
  return {
    setCurrentCreative: admaterial => dispatch(setCurrentCreative(admaterial)),
    approveMaterial: (e, admaterial, currentMatspec) =>
      dispatch(approveMaterial(e, admaterial, currentMatspec)),
    setModalVisible: val => dispatch(setModalVisible(val)),
    annotationSave: (admaterial, value, currentMatspec) =>
      dispatch(annotationSave(admaterial, value, currentMatspec))
  };
};

const mapStateToProps = state => {
  return {
    booking: state.booking,
    preflightReport: state.preflightReport,
    modalVisible: state.modalVisible,
    approving: state.approving,
    submitting: state.submitting,
    currentMatspec: state.currentMatspec,
    language: state.language,
    tableFields: state.tableFields,
    tableFieldsPrint: state.tableFieldsPrint,
    fieldTranslations: state.fieldTranslations,
    configuration: state.configuration
  };
};

class DetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { submitDisabled: true, approveDisabled: false };
  }
  onEdit = () => {
    const { admaterial, setCurrentCreative, setModalVisible } = this.props;
    console.log(admaterial);
    setModalVisible(true);
  };
  onOk = () => {
    this.setState({ visible: false });
  };
  onCancel = () => {
    const { setModalVisible } = this.props;
    setModalVisible(false);
  };
  submit = () => {
    const { annotationSave, admaterial, currentMatspec } = this.props;
    const { value } = this.state;
    annotationSave(admaterial, value, currentMatspec);
  };
  approve = e => {
    const { admaterial, approveMaterial, currentMatspec } = this.props;
    approveMaterial(e, admaterial, currentMatspec);
  };
  onChange = e => {
    const value = e.target.value;
    this.setState({
      value,
      submitDisabled: value.length === 0,
      approveDisabled: value.length > 0
    });
  };

  render() {
    const {
      admaterial,
      key,
      preflightReport,
      modalVisible,
      approving,
      submitting,
      language,
      tableFields,
      tableFieldsPrint,
      fieldTranslations,
      configuration,
      currentMatspec
    } = this.props;
    const { submitDisabled, approveDisabled } = this.state;
    const tableData = setTableFieldPairs(
      configuration.tableFieldsDetailsMobile,
      fieldTranslations,
      admaterial,
      currentMatspec
    );
    return (
      <DetailsComponent
        key={key}
        admaterial={admaterial}
        onEdit={this.onEdit}
        preflightReport={preflightReport}
        onCheck={this.onCheck}
        language={language}
        tableFields={tableFields}
        tableFieldsPrint={tableFieldsPrint}
        fieldTranslations={fieldTranslations}
        tableData={tableData}
        isClient={this.props.booking.user.rol_enum === 'CLIENT'}
      >
        <Modal
          title={
            language.data.approveOrComment
              ? language.data.approveOrComment
              : "Approve or enter comment"
          }
          visible={modalVisible}
          onCancel={this.onCancel}
          footer={
            <Row gutter={24}>
              <Col span={12}>
                <Button
                  disabled={submitDisabled}
                  loading={submitting}
                  className="d-block max-width"
                  onClick={this.submit}
                  type="primary"
                  size="small"
                >
                  {language.data.submit ? language.data.submit : "Submit"}
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  disabled={
                    !admaterial.actions ||
                    (!admaterial.actions.APPROVE && !admaterial.actions["APPROVE-NOT"] === "gam destination") ||
                    approveDisabled
                  }
                  loading={approving}
                  onClick={this.approve}
                  type="primary"
                  size="small"
                  className="btn__success d-block max-width"
                >
                  {language.data.approve ? language.data.approve : "Approve"}
                </Button>
              </Col>
            </Row>
          }
        >
          <Row gutter={12}>
            <Col span={24} style={{ padding: "6px 12px" }}>
              <TextArea
                disabled={
                  !admaterial.actions ||
                  (!admaterial.actions.APPROVE && !admaterial.actions["APPROVE-NOT"] === "gam destination") ||
                  (approveDisabled && submitDisabled)
                }
                placeholder={
                  language.data.enterNote
                    ? language.data.enterNote
                    : "enterNote"
                }
                rows="8"
                onChange={this.onChange}
                autoFocus
              />
            </Col>
          </Row>
        </Modal>
      </DetailsComponent>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailsContainer);

//THIS SHOULD BE MIGRATED TO MATSPECCOPONENT???



// WEBPACK FOOTER //
// ./src/components/Mobile/Details/DetailsContainer.js